import React from 'react';
import * as S from '../Filters.styles.js';
import { hasValues } from '../../../utils/Utils.js';
import Span from '../../Texts/Span/Span';
import Link from '../../Link/Link';
import Chip from '../../Chip/Chip';
import { typeFilters } from '../FiltersConstants.inner.js';

const getWithoutSymbol = (value) => value?.replace('$', '');

const isInteger = (value) => !!value && getWithoutSymbol(value) % 1 === 0;

const isDecimal = (value) => !!value && getWithoutSymbol(value) % 1 !== 0;

const isNumeric = (value) => isInteger(value) || isDecimal(value);

const renderPillText = (filter, currencyCode) => {
  const currencyCodeText = currencyCode === 'USD' ? 'U$S ' : '$ ';
  if (filter.type === typeFilters.RANGE) {
    const filterValues = filter.value.map((value) => {
      if (isNumeric(value)) {
        return value >= 0
          ? currencyCodeText + value
          : `-${currencyCodeText}` + value.slice(1);
      }
    });

    if (isNumeric(filterValues[0]) && isNumeric(filterValues[1])) {
      return filterValues.join(' a ');
    }
    if (!filterValues[0]) {
      filterValues[0] = 'Hasta';
      return filterValues.join(' ');
    }
    if (!filterValues[1]) {
      filterValues[1] = 'Más de';
      return filterValues.reverse().join(' ');
    }
    return filterValues;
  } else {
    if (Array.isArray(filter.value)) return filter.value.join(' - ');
    return isDecimal(filter.value)
      ? currencyCodeText + filter.value
      : filter.value;
  }
};

const FiltersPills = ({
  filters,
  removeFilter,
  clearFilters,
  currencyCode = false,
}) => {
  const FilterPill = (filterKey) =>
    filters[filterKey] && (
      <S.FilterChipWrapper>
        <Chip
          value={filters[filterKey].value}
          text={renderPillText(filters[filterKey], currencyCode)}
          onClickClose={() => removeFilter(filterKey)}
          closeButton={true}
        />
      </S.FilterChipWrapper>
    );

  return (
    <S.FilterChipsWrapper>
      <Span type='2' variant='neutral' modifier='strong'>
        Filtrado por:
      </Span>
      <S.FiltersChips>{Object.keys(filters).map(FilterPill)}</S.FiltersChips>
      {hasValues(filters) && (
        <Link variant='primary' size='sm' onClick={clearFilters}>
          Limpiar Filtros
        </Link>
      )}
    </S.FilterChipsWrapper>
  );
};

export default FiltersPills;
